import { NgModule } from '@angular/core';
import { DeprecatedMonitorWarningBannerComponent } from './deprecated-monitor-warning-banner.component';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [RouterLink, TranslateModule.forChild({})],
  declarations: [DeprecatedMonitorWarningBannerComponent],
  exports: [DeprecatedMonitorWarningBannerComponent],
})
export class DeprecatedMonitorWarningBannerModule {}
